module.exports = __webpack_public_path__ + "img/cause_57.b99655d8.svg";